// theme.js
import { createTheme } from "@mui/material/styles";
import { frFR } from "@mui/material/locale";

const theme = createTheme(
  {
    direction: "ltr",
    typography: {
      fontFamily: '"Manrope", "Roboto", "Arial", sans-serif',
    },
    palette: {
      primary: {
        light: "#8ECDDD",
        main: "#22668D",
        dark: "#252B48",
        contrastText: "#fff",
      },
      secondary: {
        light: "#FFFADD",
        main: "#FFCC70",
        contrastText: "#000",
      },
      background: {
        default: "#FFFFFF",
        paper: "#FCFCFC",
      },
    },
  },
  frFR
);

export default theme;